import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import english from "./languages/english.json";
import spanish from "./languages/spanish.json";
import haitian from "./languages/haitian.json";
import portuguese from "./languages/portuguese.json";

const resources = {
  en: {
    translation: english
  },
  es: {
    translation: spanish
  },
  ht: {
    translation: haitian
  },
  pt: {
    translation: portuguese
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('lang') || "en",
    fallbackLng: "en", // Use English if the translation key is missing
    debug: true, // Enable debug mode to log detailed information
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;